import { ProductDetailResponseDto } from "definitions/product-storage";
import { API } from "src/api";

const pendingRequests = new Map<number, Promise<ProductDetailResponseDto>>();

export async function fetchProductDetail(
  productId: number,
): Promise<ProductDetailResponseDto> {
  if (pendingRequests.has(productId)) {
    return pendingRequests.get(productId)!;
  }

  const promise = API.productStorageApi
    .productControllerGetProductDetail({ id: productId })
    .then((res) => res.data)
    .finally(() => {
      pendingRequests.delete(productId);
    });

  pendingRequests.set(productId, promise);
  return promise;
}
